import { render, staticRenderFns } from "./downloadMenu.vue?vue&type=template&id=ceb320a0&scoped=true&"
import script from "./downloadMenu.vue?vue&type=script&lang=js&"
export * from "./downloadMenu.vue?vue&type=script&lang=js&"
import style0 from "./downloadMenu.vue?vue&type=style&index=0&id=ceb320a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb320a0",
  null
  
)

/* custom blocks */
import block0 from "./downloadMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports